// eslint-disable-next-line import/prefer-default-export
export const ADDRESS = {
  entitled: 'Intitulé',
  address: 'Adresse',
  zipCode: 'Code postal',
  city: 'Ville',
  country: 'Pays',
  searchAddressByGoogleMap: 'Rechercher une adresse Google Map',
  addressCommercial: 'Adresse commerciale',
  departement: 'Département',
  agglomeration: 'Agglomération',
  lat: 'Latitude',
  long: 'Longitude',
};
